export const UPDATE_SYSTEM = 'update_system';

export function updateSystem(system) {
  return {
    type: UPDATE_SYSTEM,
    system,
  };
}
